import styled from 'styled-components';
import { Flexbox, Icon } from '@hiiretail/synergy-ui';

export const GroupRolesWrapper = styled(Flexbox)`
  width: 100%;
  min-width: 0;

  > div {
    width: 100%;
  }

  span {
    overflow-wrap: break-word;
  }

  [role='row']:first-child > [role='columnheader'] {
    :nth-child(3) {
      text-align: center;
    }

    [role='presentation'] {
      margin: 0;
      width: 0;
      height: 0;
    }
  }

  [role='row'] > div {
    flex: 1 1 auto !important;

    :nth-child(1) {
      width: 100px !important;
    }

    :nth-child(3) {
      width: 60px !important;
    }
  }
`;

export const StyledIcon = styled(Icon.Delete)`
  display: flex;
`;
